export default {
  init() {
    // JavaScript to be fired on all pages
    (function () { // eslint-disable-line func-names
      const mainNav = document.getElementById('menu-meny');
      const mainNavItem = mainNav.getElementsByClassName('nav-item');
      const mainNavLine = document.getElementById('js-navbar-line');

      function navbarLineToActive() {
        const $this = $('#menu-meny li.current-menu-item');
        if ($this.length > 0) {
          const w = $this.width();
          const p = $this.position();
          const pos = ((w - 58) + p.left);
          $(mainNavLine).css({
            left: pos,
            width: 50,
          });
        }
      }

      navbarLineToActive();

      $(mainNavItem).hover(function () { // eslint-disable-line func-names
        const $this = $(this);
        const w = $this.width();
        const p = $this.position();
        const pos = ((w - 58) + p.left);
        $(mainNavLine).css({
          left: pos,
          width: 50,
        });
      });
      $(mainNavItem).off('mouseleave');
      $(mainNavItem).on('mouseleave', () => {
        navbarLineToActive();
      });
    }());
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./src/scripts/routes/common.js